import React, { useState, useEffect } from 'react';
import Footer from './footer.js';
import TechOverlay from './tech_overlay.js';
import { Link } from 'react-router-dom';
import axios from 'axios';

import logoTec from './images/logo_tec.png';
import logoNemak from './images/logo_nemak.png';
import logoFa from './images/logo_fa.png';
import logoUanl from './images/logo_uanl.png';


const Home = () =>{

    //
    const [cover, setCover] = useState("");
    const [coverIm, setCoverIm] = useState("");
    const [coverTitle, setCoverTitle] = useState("");
   

    //
    useEffect(() => {
        callCover();
        callTitle();
    }, []);
    
    //
    async function callCover(){
        try{
            const response = await axios.get('https://api.vimeo.com/users/2185830/albums/8689807/videos', {
                headers: {
                  Authorization: `Bearer 4d4cb0e36abddc0da43d32c2480d1711`
                },
            })
            var d = response.data.data;
            setCover(d[0].uri);
            setCoverIm("url('" + d[0].pictures.sizes[6].link + "')");
            //console.log(cover);
        }catch(error){
            console.log(error);
        }	   
    }

    //
    async function callTitle(){
        try{
            const response = await axios.get('https://api.vimeo.com/users/2185830/albums/8689807', {
                headers: {
                  Authorization: `Bearer 4d4cb0e36abddc0da43d32c2480d1711`
                },
            })
            var x = response.data;
            //console.log(x.description);
            setCoverTitle(x.description);
        }catch(error){
            console.log(error);
        }	   
    }

    
    return(

        <div className="cover_main">

            {
                cover === ""
            ?   
            
            <div className="load_screen">CARGANDO...</div>

            :
            <div className="cover" style={{backgroundImage: coverIm}}>
                <TechOverlay/>
                <div className="cover_info">
                    <h1 className="covertitle">{coverTitle}</h1>
                    <Link className="actionbtn" to="/work">EXPLORA NUESTRO TRABAJO</Link>
                    <div className="cover_clients">
                        <p className="clients_label">HEMOS COLABORADO CON:</p>
                        <div className="clients_logos">
                            <img src={logoTec} alt="Tecnológico de Monterrey"/>
                            <img src={logoNemak} alt="Nemak"/>
                            <img src={logoFa} alt="FA"/>
                            <img src={logoUanl} alt="Universidad Autónoma de Nuevo León"/>
                        </div>
                    </div>
                </div>
                <div className="foot">
                    <Footer/>
                </div>
            </div>
            }
        </div>   
    )
}

export default Home;